import { Modal } from 'antd';
import { FC } from 'react';

interface TaskNotAvailableDialogProps {
  open: boolean;
  onPickup: () => void;
  onClose: () => void;
}

export const TaskNotAvailableDialog: FC<TaskNotAvailableDialogProps> = ({
  open,
  onPickup,
  onClose,
}) => {
  const onOk = () => {
    onClose();
    onPickup();
  };
  return (
    <Modal title="Task Queue Empty" open={open} onOk={onOk} onCancel={onClose}>
      <p>
        The task you were assigned is no longer available. Would you like to
        pickup a new task?
      </p>
    </Modal>
  );
};
